import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";

import HomePage from "@/pages/HomePage";
import SalePage from "@/pages/SalePage";
import ConsignorsPage from "@/pages/ConsignorsPage";
import ConsignorDetailPage from "@/pages/ConsignorDetailPage";
import NoteworthyBullsPage from "@/pages/NoteworthyBullsPage";
import NotableBullsPage from "@/pages/NotableBullsPage";
import LegacyBuyerInfoPage from "@/pages/LegacyBuyerInfoPage";
import HeterosisPage from "@/pages/HeterosisPage";
import DonorCowsPage from "@/pages/DonorCowsPage";
import AccreditationPage from "@/pages/AccreditationPage";
import BuyerInfoPage from "@/pages/BuyerInfoPage";
import FlyerLegacyPage from "@/pages/FlyerLegacyPage";
import FlyerSocialPage from "@/pages/FlyerSocialPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider, useAuth } from "@/lib/auth";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="admin-shell flex items-center justify-center"><div className="text-sm" style={{ color: "var(--text-muted)" }}>Loading…</div></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/sale/:slug" element={<SalePage />} />
          <Route path="/consignors" element={<ConsignorsPage />} />
          <Route path="/consignor/:slug" element={<ConsignorDetailPage />} />
          <Route path="/noteworthy-bulls" element={<NoteworthyBullsPage />} />
          <Route path="/notable-bulls" element={<NotableBullsPage />} />
          <Route path="/donor-cows" element={<DonorCowsPage />} />
          <Route path="/sires" element={<Navigate to="/noteworthy-bulls#bloodlines" replace />} />
          <Route path="/accreditation" element={<AccreditationPage />} />
          {/* /videos and /sale-terms redirect to merged destinations */}
          <Route path="/videos" element={<Navigate to="/" replace />} />
          <Route path="/sale-terms" element={<Navigate to="/buyer-info#terms" replace />} />
          <Route path="/buyer-info" element={<BuyerInfoPage />} />
          <Route path="/buyer-info/legacy" element={<LegacyBuyerInfoPage />} />
          <Route path="/heterosis" element={<HeterosisPage />} />
          <Route path="/flyer/legacy" element={<FlyerLegacyPage />} />
          <Route path="/flyer/legacy/:variant" element={<FlyerSocialPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
